import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import News from './News/News';
import logo from "../Header/Images/RMB-Strip-Jaipur.png";
import { MdSpaceDashboard } from "react-icons/md";
import { MdPostAdd } from "react-icons/md";
import { HiMiniInformationCircle } from "react-icons/hi2";


import { FaUsers } from "react-icons/fa";
import HomeBanner from './Banners/HomeBanner';
import { IoMdArrowDropdownCircle } from "react-icons/io";
import { IoImagesSharp } from "react-icons/io5";
import { PiGiftBold } from "react-icons/pi";

import { CgArrowLongRightC } from "react-icons/cg";
import { MdRateReview } from "react-icons/md";

import AboutBanner from './Banners/AboutBanner';
import MemberBanner from './Banners/MemberBanner';
import MeetingsBanner from './Banners/MeetingsBanner';
import DirectorsBanner from './Banners/DirectorsBanner';
import ContactBanner from './Banners/ContactBanner';
import { MdOutlineBusinessCenter } from "react-icons/md";
import { TfiGallery } from "react-icons/tfi";

import { PiSelectionBackgroundFill } from "react-icons/pi";
import { GoCrossReference } from "react-icons/go";

import { GiOpenFolder } from "react-icons/gi";
import About from './Pages/About';
import RMBLeader from './Pages/RMBLeader';
import RMBJaipur from './Pages/RMBJaipur';
import MemberPage from './Pages/MemberPage';
import MeetingPage from './Pages/MeetingPage';
import LeadershipPage from './Pages/LeadershipPage';
import ContactPage from './Pages/ContactPage';
import Tags from './Tags/Tags';
import Category from './Category/Category';
import Siteinfo from './Siteinfo/Siteinfo';

import { FaTags } from "react-icons/fa6";


import { BiSolidContact } from "react-icons/bi";


import { PiPresentationChart } from "react-icons/pi";

import { RiLogoutBoxLine } from "react-icons/ri";


import { TbReportAnalytics } from "react-icons/tb";
import DashbordHome from './DashbordHome/DashbordHome';

import { MdCategory } from "react-icons/md";


import { FaCodeBranch } from "react-icons/fa6";


interface UserDetails {
  id: number;
  name: string;
  email: string;
  // Add other fields as per your database schema
}

const Dashboard = () => {
  const api = process.env.REACT_APP_API_URL as string;
  const [name, setName] = useState<string | null>(null); // Initialize name state
  const navigate = useNavigate(); // Initialize navigate
  const[tabs, setTabs]  = useState<string>("Dashboard");
  const[userdeatils ,setUserdeatils] = useState<UserDetails | null>(null);

   const [menuOpen, setMenuOpen] = useState(false);


  const[bannerMenu,setBannerMenu] = useState<Boolean>(false);
  const[pageMenu,setPageMenu] = useState<Boolean>(false);

  useEffect(() => {
    const validateSession = async () => {
      try {
        const response = await axios.get(`${api}/auth/dashboard`, {
          withCredentials: true,
        });
      

        const uid = response.data.userId;
       
        const userResponse = await axios.get(`${api}/auth/user/${uid}`, {
          withCredentials: true,
        });
        setUserdeatils(userResponse.data);
     
        setName(response.data.userId); // Set name from response
      } catch (error: any) {
        // console.error('Session validation failed:', error.response?.data || error.message);
        navigate('/login'); // Redirect to login if session validation fails
      }
    };

    validateSession();
  }, [navigate]);

  return (
    <div>
      <div className="flex relative bg-[#CBD5E0]">
        
  {/* Sidebar Section */}
  <div className={`fixed top-0 left-0 h-screen w-[70%] lg:w-[18%] bg-darkblue text-white z-40 transform ${
          menuOpen ? "translate-x-0" : "-translate-x-full"
        } lg:translate-x-0 transition-transform duration-300`}>
    {/* Logo */}

    <div className="w-[230px]  top-4 hidden">
      <img
        src={logo}
        alt="Logo"
        className="rounded-lg drop-shadow-2xl bg-white p-2"
      />
    </div>

    {/* Dashboard Tab */}
    <div className='w-full overflow-y-auto scrollbar-hide  h-[93lvh] mt-3'>
    <div
      className={`w-full h-[48px] flex  cursor-pointer text-white justify-start pl-4 gap-4 text-base items-center hover:text-[#FDBC12] ${
        tabs === "Dashboard" ? "border-r-4 border-[#FDBC12] !text-[#FDBC12]" : ""
      }`}
      onClick={() => setTabs("Dashboard")}
    >
      <MdSpaceDashboard className="text-2xl" /> <h5>Dashboard</h5>
    </div>



    {/* News Tab */}
    <div
      className={`w-full h-[48px] flex cursor-pointer text-white justify-start pl-4 gap-4 text-base items-center hover:text-[#FDBC12] ${
        tabs === "News" ? "border-r-4 border-[#FDBC12] !text-[#FDBC12]" : ""
      }`}
      onClick={() => setTabs("News")}
    >
      <MdPostAdd className="text-2xl" /> <h5>News</h5>
    </div>
    {/* tags */}
     <div
      className={`w-full h-[48px] flex cursor-pointer text-white justify-start pl-4 gap-4 text-base items-center hover:text-[#FDBC12] ${
        tabs === "Tags" ? "border-r-4 border-[#FDBC12] !text-[#FDBC12]" : ""
      }`}
      onClick={() => setTabs("Tags")}
    >
      <FaTags className="text-2xl" /> <h5>Tags</h5>
    </div>
    
   {/* category */}
     <div
      className={`w-full h-[48px] flex cursor-pointer text-white justify-start pl-4 gap-4 text-base items-center hover:text-[#FDBC12] ${
        tabs === "Category" ? "border-r-4 border-[#FDBC12] !text-[#FDBC12]" : ""
      }`}
      onClick={() => setTabs("Category")}
    >
      <MdCategory className="text-2xl" /> <h5>Category</h5>
    </div>

    {/* Site Info */}
     <div
      className={`w-full h-[48px] flex cursor-pointer text-white justify-start pl-4 gap-4 text-base items-center hover:text-[#FDBC12] ${
        tabs === "Siteinfo" ? "border-r-4 border-[#FDBC12] !text-[#FDBC12]" : ""
      }`}
      onClick={() => setTabs("Siteinfo")}
    >
      <HiMiniInformationCircle className="text-2xl" /> <h5>SiteInfo</h5>
    </div>
    
    </div>
    <div
    className={`w-full h-[48px] flex cursor-pointer text-white justify-start pl-4 gap-4 text-base items-center hover:text-[#FDBC12] `}
    onClick={()=>{window.location.href = '/login'}}
  >
    <div className="text-2xl"><RiLogoutBoxLine/></div> <h5>Logout</h5>
  </div>
  </div>

  {/* Header for Mobile */}
  <div className="lg:hidden bg-darkblue text-white px-4 py-3 flex items-center justify-between fixed top-0 left-0 w-full z-10">
      <img src={logo} alt="Logo" className="w-[50%] object-contain drop-shadow-2xl" />
      <button
        className="relative w-8 h-8 focus:outline-none"
        onClick={() => setMenuOpen(!menuOpen)}
      >
        {/* Animated Hamburger Icon */}
        <div
          className={`relative w-8 h-1 bg-white rounded transition-transform duration-300 transform ${
            menuOpen ? "rotate-45 translate-y-[10px]" : ""
          }`}
        ></div>
        <div
          className={`relative w-8 h-1 bg-white rounded my-[6px] transition-opacity duration-300 ${
            menuOpen ? "opacity-0" : "opacity-100"
          }`}
        ></div>
        <div
          className={`relative w-8 h-1 bg-white rounded transition-transform duration-300 transform ${
            menuOpen ? "-rotate-45 -translate-y-[10px]" : ""
          }`}
        ></div>
      </button>
    </div>
   {/* Overlay for Small Screens */}
   {menuOpen && (
    <div
      className="fixed inset-0 bg-black opacity-50 z-10 lg:hidden"
      onClick={() => setMenuOpen(false)}
    />
  )}

  {/* Content Section */}
  <div className={`lg:ml-[18%] lg:w-[82%] bg-[#CBD5E0] min-h-screen transition-all duration-300 lg:mt-0 mt-24 ml-[0%] w-[100%]`}>
    {tabs === "News" && <News />}
    {tabs === "Dashboard" && <DashbordHome />}

    {tabs === "Tags" && <Tags/>}
    {tabs === "Category" && <Category/>}
  
    {tabs ==="HomeBanner" && <HomeBanner />}
    {tabs ==="AboutBanner" && <AboutBanner />}
    {tabs ==="MemberBanner" && <MemberBanner />}
    {tabs ==="MeetingBanner" && <MeetingsBanner />}
    {tabs ==="DirectorBanner" && <DirectorsBanner />}
    {tabs ==="ContactBanner" && <ContactBanner />}
  
    {tabs ==="AboutRMB" && <About />}
    {tabs ==="RMBLeader" && <RMBLeader />}
    {tabs ==="RMBJaipur" && <RMBJaipur />}
    {tabs ==="MemberPage" && <MemberPage />}
    {tabs ==="MeetingPage" && <MeetingPage />}
    {tabs ==="LeadershipPage" && <LeadershipPage/>}
    {tabs ==="ContactPage" && <ContactPage/>}
    {tabs ==="Siteinfo" && <Siteinfo/>}
  

  

  </div>
</div>

       
      
      
    </div>
  );
};


type MenuItemProps = {
  label: string;
  activeTab: string;
  tabKey: string;
  icon: React.ReactNode; // Type for JSX/React components
  onClick: () => void;   // Type for a function with no arguments and no return value
};
const MenuItem: React.FC<MenuItemProps> = ({ label, activeTab, tabKey, icon, onClick }) => (
  <div
    className={`w-full h-[48px] flex cursor-pointer text-white justify-start pl-4 gap-4 text-base items-center hover:text-[#FDBC12] ${
      activeTab === tabKey ? "border-r-4 border-[#FDBC12] !text-[#FDBC12]" : ""
    }`}
    onClick={onClick}
  >
    <div className="text-2xl">{icon}</div> <h5>{label}</h5>
  </div>
);

export default Dashboard;
